import { Tabs, Tab } from '@mui/material';
import { HIVEBOARD } from '../assets/constants/Constants';

export function RenderTabs({
  isMobileOtpEnabled = false,
  isEmailOtpEnabled = false,
  isFirstTab = false,
  isSecondTab = false,
  FirstTabLabalName = "firstLabal",
  SecondTabLabalName = "SecondLabal",
  tabValue,
  onChange,
  t,
  customer
}) {
  const tabs = [];

  // First Tab
  if (isMobileOtpEnabled || isFirstTab) {
    tabs.push({
      label: isMobileOtpEnabled
        ? t("phoneNumberLabel")
        : t(FirstTabLabalName)
    });
  }

  // Second Tab
  if (isEmailOtpEnabled || isSecondTab) {
    tabs.push({
      label: isEmailOtpEnabled
        ? t("emailAddressLabel")
        : t(SecondTabLabalName)
    });
  }

  if (customer === HIVEBOARD) {
    return (
      <Tabs
        className="tab-bar"
        classes={{ indicator: "indicator-style" }}
        value={tabValue}
        onChange={(event, newValue) => onChange(newValue)}
        aria-label="basic tabs example"
      >
        {tabs.map((tab, index) => (
          <Tab key={index} className="tab-bar-label" label={tab.label} />
        ))}
      </Tabs>
    );
  }

  return (
    <div className="render-tabs-bar">
      {tabs.map((tab, index) => (
        <button
          key={index}
          className={`render-tabs-bar-label ${tabValue === index ? "active" : ""}`}
          onClick={() => onChange(index)}
        >
          {tab.label}
        </button>
      ))}
      <div
        className="render-tabs-indicator"
        style={{
          width: `${100 / tabs.length}%`,
          transform: `translateX(${tabValue * 100}%)`
        }}
      />
    </div>
  );
}
